import { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";

/**
 * MarqueeText - Automatically scrolls text that overflows its container.
 * Scrolls to end, pauses, scrolls back, pauses, and loops.
 */
const MarqueeText = ({
  text,
  maxWidth = 180,
  textClassName = "text-sm font-medium text-gray-900",
}) => {
  const textRef = useRef(null);
  const [needsMarquee, setNeedsMarquee] = useState(false);
  const [scrollDistance, setScrollDistance] = useState(0);

  useEffect(() => {
    if (textRef.current) {
      const textWidth = textRef.current.scrollWidth;
      const containerWidth = maxWidth;
      if (textWidth > containerWidth) {
        setNeedsMarquee(true);
        setScrollDistance(textWidth - containerWidth + 10); // +10 for padding
      } else {
        setNeedsMarquee(false);
      }
    }
  }, [text, maxWidth]);

  return (
    <div className="overflow-hidden" style={{ maxWidth }}>
      <div
        ref={textRef}
        /* eslint-disable-next-line tailwindcss/classnames-order */
        className={`whitespace-nowrap ${textClassName} ${needsMarquee ? "animate-marquee-scroll" : ""}`}
        style={
          needsMarquee ? { "--marquee-distance": `-${scrollDistance}px` } : {}
        }
      >
        {text}
      </div>
    </div>
  );
};

MarqueeText.propTypes = {
  text: PropTypes.string.isRequired,
  maxWidth: PropTypes.number,
  textClassName: PropTypes.string,
};

export default MarqueeText;
